import { render, staticRenderFns } from "./LpuSetCard.vue?vue&type=template&id=744d152d&scoped=true&"
import script from "./LpuSetCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuSetCard.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuSetCard.vue?vue&type=style&index=0&id=744d152d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744d152d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744d152d')) {
      api.createRecord('744d152d', component.options)
    } else {
      api.reload('744d152d', component.options)
    }
    module.hot.accept("./LpuSetCard.vue?vue&type=template&id=744d152d&scoped=true&", function () {
      api.rerender('744d152d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuSetCard.vue"
export default component.exports